<template>
  <section id="honors" class="h25-section alt">
    <div class="h25-container">
      <div class="h25-sec-hd center">
        <div class="label">Qualifications</div><h2>资质荣誉</h2>
        <p>以专业资质和行业认可为基石，保障每一项交付的品质与合规</p>
      </div>
      <div class="honor-grid">
        <div class="honor-card" v-for="h in honors" :key="h.title">
          <div class="honor-img"><img :src="h.img" :alt="h.title" /></div>
          <div class="honor-info"><h5>{{ h.title }}</h5><p>{{ h.desc }}</p></div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name:'HonorsSection',
  data(){return{honors:[
    {title:'高新技术企业认证',desc:'国家级高新技术企业认定',img:require('@/assets/honorImages/高新技术企业认证.png')},
    {title:'软件企业证书',desc:'双软认证软件企业',img:require('@/assets/honorImages/软件企业证书.png')},
    {title:'ISO9001质量认证',desc:'质量管理体系认证',img:require('@/assets/honorImages/ISO9001质量认证.png')},
    {title:'ISO27001信息安全认证',desc:'信息安全管理体系认证',img:require('@/assets/honorImages/ISO27001信息安全管理认证.png')},
    {title:'CMMI3企业认证',desc:'软件能力成熟度三级',img:require('@/assets/honorImages/CMMI3企业认证.png')},
    {title:'专精特新中小企业',desc:'专精特新中小企业认证',img:require('@/assets/honorImages/专精特新中小企业认证.png')},
    {title:'3A级信用企业',desc:'企业信用等级AAA级',img:require('@/assets/honorImages/3A级信用企业.png')},
    {title:'智慧园区软件产品证书',desc:'自主知识产权产品认证',img:require('@/assets/honorImages/智慧园区软件产品证书.png')},
    {title:'低碳信息系统麒麟认证',desc:'麒麟软件适配认证',img:require('@/assets/honorImages/低碳信息管理系统麒麟软件认证.png')},
    {title:'售后服务认证证书',desc:'五星级售后服务认证',img:require('@/assets/honorImages/售后服务认证证书.png')}
  ]}}
}
</script>
<style scoped>
.honor-grid{display:grid;grid-template-columns:repeat(auto-fit,minmax(200px,1fr));gap:16px}
.honor-card{border:1px solid var(--h25-border);border-radius:var(--h25-radius);overflow:hidden;background:var(--h25-white);transition:all .3s}
.honor-card:hover{border-color:var(--h25-muted2)}
.honor-img{width:100%;height:200px;background:var(--h25-bg);display:flex;align-items:center;justify-content:center;overflow:hidden}
.honor-img img{width:100%;height:100%;object-fit:contain;padding:12px}
.honor-info{padding:12px 16px}
.honor-info h5{font-size:14px;font-weight:700;color:var(--h25-text);margin-bottom:3px}
.honor-info p{font-size:12px;color:var(--h25-muted)}
</style>
